import { assign, entryId, restoreSequence } from "../../helper.js";
import { isBoolean, isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/table.entity.js
var createTable = () => ({
	id: "",
	name: "",
	logicalName: "",
	comment: "",
	columnIds: [],
	seqColumnIds: [],
	groupId: "",
	nameDerived: false,
	ui: {
		x: 200,
		y: 100,
		zIndex: 2,
		widthName: 60,
		widthLogicalName: 60,
		widthComment: 60,
		color: ""
	}
});
function createAndMergeTableEntities(json) {
	const entities = {};
	if (!isPlainObject(json) || isNil(json)) return entities;
	for (const [key, value] of Object.entries(json)) {
		if (!isPlainObject(value)) continue;
		const target = createTable();
		const assignString = assign(isString, target, value);
		const assignArray = assign(Array.isArray, target, value);
		const assignBoolean = assign(isBoolean, target, value);
		const uiAssignNumber = assign(isNumber, target.ui, value.ui);
		const uiAssignString = assign(isString, target.ui, value.ui);
		target.id = entryId(key, value);
		assignString("name");
		assignString("logicalName");
		assignString("comment");
		assignString("groupId");
		assignBoolean("nameDerived");
		assignArray("columnIds");
		assignArray("seqColumnIds");
		uiAssignString("color");
		uiAssignNumber("x");
		uiAssignNumber("y");
		uiAssignNumber("zIndex");
		uiAssignNumber("widthName");
		uiAssignNumber("widthLogicalName");
		uiAssignNumber("widthComment");
		target.seqColumnIds = restoreSequence(target.columnIds, target.seqColumnIds);
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeTableEntities, createTable };
